/**
 * CMS已经国际化语种的路径
 */
export const CMS_LOCALES_PATH = ['/audio-to-text'];

/**
 * 本地已经国际化语种的路径
 */
export const NATIVE_LOCALES_PATH = [
  '/tools/audio-to-text-converter',
  '/tools/youtube-video-summarizer',
  '/tools/video-to-text',
];

/**
 * audio-to-text-converter页面的Explore More已国际化语种的路径
 */
export const AUDIO_TO_TEXT_CONVERTER_EXPLORE_MORE_LOCALES_PATH = [
  '/mp3-to-text',
  '/video-to-text',
  '/youtube-to-text',
  '/mp4-to-text',
];

/**
 * 支持的页面语言
 */
export const SUPPORT_PAGE_LANGUAGES = [
  'en',
  'ja',
  'fr',
  'es',
  'pt',
  'id',
  'cs',
  'de',
  'it',
  'nl',
  'pl',
  'tr',
  'uk',
  'ko',
  'ar',
  'fa',
  'th',
  'hi',
  'vi',
];

export const ALL_TRANSCRIPT_LANGUAGES = [
  'ar-EG',
  'hy-AM',
  'az-AZ',
  'su-ID',
  'bg-BG',
  'ca-ES',
  'zh-HK',
  'zh-CN',
  'zh-TW',
  'hr-HR',
  'cs-CZ',
  'da-DK',
  'nl-NL',
  'en-US',
  'fil-PH',
  'fi-FI',
  'fr-FR',
  'ka-GE',
  'de-DE',
  'el-GR',
  'gu-IN',
  'he-IL',
  'hi-IN',
  'hu-HU',
  'is-IS',
  'id-ID',
  'it-IT',
  'ja-JP',
  'jv-ID',
  'kn-IN',
  'km-KH',
  'ko-KR',
  'lo-LA',
  'lv-LV',
  'lt-LT',
  'ms-MY',
  'ne-NP',
  'nb-NO',
  'fa-IR',
  'pl-PL',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sr-RS',
  'si-LK',
  'sk-SK',
  'sl-SI',
  'es-ES',
  'sw-KE',
  'sv-SE',
  'ta-IN',
  'te-IN',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'ur-IN',
  'vi-VN',
  'zu-ZA',
];

export const FREE_TRANSCRIPT_LANGUAGES = [
  'en-US',
  'nl-NL',
  'fr-FR',
  'de-DE',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'pt-PT',
  'ru-RU',
  'es-ES',
  'tr-TR',
  'uk-UA',
  'vi-VN',
];
